export default {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Aller à',
  jump_to_confirm: 'confirmer',
  page: '',

  // Pagination.jsx
  prev_page: 'Page précédente',
  next_page: 'Page suivante',
  prev_5: '5 Pages précédentes',
  next_5: '5 Pages suivantes',
  prev_3: '3 Pages précédentes',
  next_3: '3 Pages suivantes'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-pagination@1.15.1@rc-pagination/es/locale/fr_FR.js
// module id = 1119
// module chunks = 0